import type { DiscountType } from "@shared/graphql.types";
import { calcDiscountPrice } from "./calcDiscountPrice";
import { getDiscountEffectsByTargetType } from "./getDiscountEffectsByTargetType";

export const getBasketTotalDiscountedPrice = (
  totalPrice: number,
  userDiscounts: Array<DiscountType> = []
): number => {
  const basketTotalEffects = getDiscountEffectsByTargetType(
    "basket_total",
    userDiscounts
  );

  if (!basketTotalEffects.length) return totalPrice;

  return calcDiscountPrice(basketTotalEffects, totalPrice);
};
